// extracted by mini-css-extract-plugin
export default {"root":"IconGreengrocer_root__BghY-"};